import { z } from 'zod/v3';

const ConfigSchema = z.object({
  apiUrl: z.string().default('https://app.cotera.co'),
  posthogKey: z.string().optional(),
  sentryDsn: z.string().optional(),
  gtmId: z.string().optional(),
  allowNavigationBlocker: z.boolean().optional().default(false),
  workosClientId: z.string(),
  workosApiHostname: z.string().optional(),
});

export const config = ConfigSchema.parse((window as any).COTERA_CONFIG ?? {});
